export default "__VITE_ASSET__de170a6d__"